/**
 * The build stamped into this bundle by scripts/deploy.ts: an increasing build number (the
 * commit count), the commit, and the build time in Eastern Time. Local builds say "dev".
 */
const number = import.meta.env.VITE_BUILD_NUMBER as string | undefined;
const hash = import.meta.env.VITE_BUILD_HASH as string | undefined;
const time = import.meta.env.VITE_BUILD_TIME as string | undefined;

export const BUILD_TEXT = number && hash && time ? `Build ${number} · ${hash} · ${time}` : 'Build dev';

/** The environment this bundle was built for (scripts/deploy.ts); unset in local builds. */
export const ENVIRONMENT = (import.meta.env.VITE_ENVIRONMENT as string | undefined) ?? 'local';
export const IS_STAGING = ENVIRONMENT === 'staging';
